import React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getTimeWithTimeZoneAbbreviationNew } from '../Utils/helperFns';
dayjs.extend(utc);
dayjs.extend(timezone);
interface Props {
  id: string;
  label?: string;
  placeholder?: string;
  name: string;
  type?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  defaultValue?: string | number;
  variant?: 'outlined' | 'standard' | 'filled' | undefined;
  requiredField?: boolean;
  control: any;
  minutesStep?: number;
  value?: any;
  onChange?: any;
  minSelectableTime?: any;
  validate?: any;
  onClose?: any;
  open?: any;
  onClick?: any;
  minTime?: any;
  isRisk?: any;
}
export default function TimePicker(props: Props) {
  const {
    id,
    label,
    placeholder,
    name,
    type,
    helperText,
    error,
    disabled,
    defaultValue,
    variant,
    requiredField,
    control,
    minutesStep,
    value,
    onChange,
    minSelectableTime = null,
    validate,
    onClose,
    open,
    onClick,
    minTime,
    isRisk,
  } = props;
  return (
    <>
      {control && !validate && !isRisk ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue} // Set default value to null
          render={({ field }) => (
            <FormControl
              fullWidth
              // className={`dateInput ${error ? 'border-red' : ''}`}
              error={error ? true : false}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <FormLabel className="formLabel">
                  {label} {requiredField ? <sup>*</sup> : null}{' '}
                </FormLabel>
                <MobileTimePicker
                  {...field}
                  value={field.value ? dayjs(field.value) : null}
                  onAccept={val => {
                    field.onChange(val); // update RHF value

                    if (onChange) onChange(val); // call external handler if passed
                  }}
                  minTime={minTime}
                  onClose={() => {
                    field.onBlur(); //  manually mark as touched when picker closes
                    if (onClose) onClose(); // keep your custom onClose if needed
                  }}
                  slotProps={{
                    textField: {
                      // helperText: helperText,
                      id: id,
                      error: error || false,
                      variant: variant,
                      size: 'small',
                      // inputProps: {
                      //   value: field.value
                      //     ? `${dayjs(field.value).format('hh:mm A')} ${moment
                      //       .tz(moment.tz.guess())
                      //       .format('z')}`
                      //     : '',
                      //   readOnly: true,
                      // },
                      InputProps: {
                        endAdornment: (
                          <>
                            <div className="inputEndIcon">
                              <IconButton>
                                <AccessTimeIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </>
                        ),
                      },
                      placeholder: placeholder ?? 'HH:MM',
                    },
                  }}
                  disabled={disabled}
                  defaultValue={defaultValue || null}
                  minutesStep={minutesStep || 1}
                />
              </LocalizationProvider>
              <FormHelperText className={error ? 'helper-error' : ''}>
                {helperText}
              </FormHelperText>
            </FormControl>
          )}
        />
      ) : validate && !isRisk ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          // Set default value to null
          render={({ field }) => (
            <FormControl
              fullWidth
              className={`dateInput ${error ? 'border-red' : ''}`}
              error={error ? true : false}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <FormLabel className="formLabel">
                  {label} {requiredField ? <sup>*</sup> : null}{' '}
                </FormLabel>
                <MobileTimePicker
                  value={value || null}
                  onAccept={val => {
                    if (onChange) onChange(val); // call external handler if passed
                  }}
                  slotProps={{
                    textField: {
                      // helperText: helperText,

                      variant: variant,
                      size: 'small',
                      // inputProps: {
                      //   value: field.value
                      //     ? `${dayjs(field.value).format('hh:mm A')} ${moment
                      //       .tz(moment.tz.guess())
                      //       .format('z')}`
                      //     : '',
                      //   readOnly: true,
                      // },
                      InputProps: {
                        endAdornment: (
                          <>
                            <div className="inputEndIcon">
                              <IconButton>
                                <AccessTimeIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </>
                        ),
                      },
                      placeholder: placeholder ?? 'HH:MM',
                    },
                  }}
                  disabled={disabled}
                  defaultValue={defaultValue || null}
                  minutesStep={minutesStep || 1}
                />
              </LocalizationProvider>
              <FormHelperText className={error ? 'helper-error' : ''}>
                {helperText}
              </FormHelperText>
            </FormControl>
          )}
        />
      ) : isRisk ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue} // Set default value to null
          render={({ field }) => (
            <FormControl
              fullWidth
              // className={`dateInput ${error ? 'border-red' : ''}`}
              error={error ? true : false}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <FormLabel className="formLabel">
                  {label} {requiredField ? <sup>*</sup> : null}{' '}
                </FormLabel>
                <MobileTimePicker
                  {...field}
                  value={field.value ? dayjs(field.value) : null}
                  onAccept={val => {
                    field.onChange(val); // update RHF value

                    if (onChange) onChange(val); // call external handler if passed
                  }}
                  minTime={minTime}
                  onClose={() => {
                    field.onBlur(); //  manually mark as touched when picker closes
                    if (onClose) onClose(); // keep your custom onClose if needed
                  }}
                  slotProps={{
                    textField: {
                      // helperText: helperText,
                      id: id,
                      error: error || false,
                      variant: variant,
                      size: 'small',
                      inputProps: {
                        value: field.value
                          ? `${dayjs(field.value).format(
                              'hh:mm A',
                            )} ${getTimeWithTimeZoneAbbreviationNew(
                              dayjs(field.value).toDate(),
                              'z',
                            )}`
                          : '',
                        readOnly: true,
                      },
                      InputProps: {
                        endAdornment: (
                          <>
                            <div className="inputEndIcon">
                              <IconButton>
                                <AccessTimeIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </>
                        ),
                      },
                      placeholder: placeholder ?? 'HH:MM',
                    },
                  }}
                  disabled={disabled}
                  defaultValue={defaultValue || null}
                  minutesStep={minutesStep || 1}
                />
              </LocalizationProvider>
              <FormHelperText className={error ? 'helper-error' : ''}>
                {helperText}
              </FormHelperText>
            </FormControl>
          )}
        />
      ) : (
        <FormControl
          fullWidth
          className={`customSelect dateInput ${error ? 'border-red' : ''}`}
          error={error ? true : false}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FormLabel className="formLabel">
              {label} {requiredField ? <sup>*</sup> : null}{' '}
            </FormLabel>
            <MobileTimePicker
              slotProps={{
                textField: {
                  // helperText: helperText,
                  variant: variant,

                  size: 'small',
                  // inputProps: {
                  //   value: field.value
                  //     ? `${dayjs(field.value).format('hh:mm A')} ${moment
                  //       .tz(moment.tz.guess())
                  //       .format('z')}`
                  //     : '',
                  //   readOnly: true,
                  // },
                  InputProps: {
                    endAdornment: (
                      <>
                        <div className="inputEndIcon">
                          <IconButton>
                            <AccessTimeIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </>
                    ),
                  },
                },
              }}
              disabled={disabled}
              minutesStep={minutesStep || 1}
              value={value}
              onChange={onChange}
              defaultValue={defaultValue}
            />
          </LocalizationProvider>
          <FormHelperText className={error ? 'helper-error' : ''}>
            {helperText}
          </FormHelperText>
        </FormControl>
      )}
    </>
  );
}
